// Common/DatePicker.js
import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import styled from 'styled-components';

const StyledDatePicker = styled(DatePicker)`
  padding: 8px;
  margin-bottom: 10px;
  border-style: solid;
  border-color: ${props => props.$invalid ? 'red' : '#ccc'};
  border-radius: ${props => props.$invalid ? '8px' : '4px'};
  width: 250px;
`;

const CustomDatePicker = ({
  selected,
  onChange,
  placeholder = "Selecciona una fecha",
  isRequired = false
}) => {
  const isInvalid = isRequired && !selected;

  return (
      <StyledDatePicker
        selected={selected}
        onChange={onChange}
        showYearDropdown
        showMonthDropdown
        dateFormat="dd/MM/yyyy"
        dropdownMode="select"
        placeholderText={placeholder}
        $invalid={isInvalid}
      />
  );
};

export default CustomDatePicker;
